import React, { useEffect, useRef, useImperativeHandle, forwardRef } from 'react';

// Minimal WYSIWYG editor for bold/italic using contentEditable
// Props: value (html string), onChange(html), placeholder (string), disabled (bool)
const RichTextEditorBasic = forwardRef(function RichTextEditorBasic(
  { value, onChange, placeholder = '', disabled = false },
  ref
) {
  const innerRef = useRef(null);

  useImperativeHandle(ref, () => ({
    getHtml: () => innerRef.current?.innerHTML ?? '',
  }));

  useEffect(() => {
    if (innerRef.current && innerRef.current.innerHTML !== (value || '')) {
      innerRef.current.innerHTML = value || '';
    }
  }, [value]);

  const emitChange = () => {
    const html = innerRef.current ? innerRef.current.innerHTML : '';
    onChange && onChange(html);
  };

  const exec = (cmd) => {
    try {
      document.execCommand(cmd, false);
      emitChange();
    } catch (_) {}
  };

  return (
    <div>
      <div className="d-flex gap-2 mb-1">
        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => exec('bold')} disabled={disabled}><strong>B</strong></button>
        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => exec('italic')} disabled={disabled}><em>I</em></button>
      </div>
      <div
        ref={innerRef}
        contentEditable={!disabled}
        onInput={emitChange}
        onBlur={emitChange}
        className="form-control"
        style={{ minHeight: 96, overflowY: 'auto' }}
        data-placeholder={placeholder}
      />
      <style>{`
        [contenteditable=true][data-placeholder]:empty:before {
          content: attr(data-placeholder);
          color: #6c757d;
        }
      `}</style>
    </div>
  );
});

export default RichTextEditorBasic;
